import Countdown from './countdown.vue';

export default Countdown;
